import { Warehouses } from '../../../reducers/warehouses/types';
import { UPDATE_WAREHOUSES, UpdateWarehousesAction } from './types';

export function updateWarehouses(warehouses: Warehouses): UpdateWarehousesAction {
    return {
        type: UPDATE_WAREHOUSES,
        payload: warehouses,
    };
}
